// IncubationServices.js - Service functions for incubation management
import { defaultDataFields, incubationDataFields } from './SampleDatabase';

/**
 * Returns an array of default data fields for creating a new incubation
 * @returns {Array} Array of default field objects
 */
export const getDefaultIncubationFields = () => {
  // Transform the defaultDataFields from SampleDatabase into form-ready format
  const formFields = defaultDataFields.map(field => ({
    id: field.name,
    label: field.name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
    type: field.type,
    value: '',
    required: field.type !== 'textarea' && field.name !== 'health_conditions'
  }));

  // Add activity level options for select type
  const activityField = formFields.find(field => field.id === 'activity_level');
  if (activityField) {
    activityField.options = ['Low', 'Moderate', 'High', 'Very High'];
  }

  return formFields;
};
